import React, { Component } from "react";
import { reduxForm, Field } from "redux-form";
import { connect } from "react-redux";
import { FormGroup, Col, Label, Input, Row, Button, Spinner } from "reactstrap";
//import DropdownList from 'react-widgets/lib/DropdownList'
//import 'react-widgets/dist/css/react-widgets.css'

import TextField from '@material-ui/core/TextField'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import DateTimePicker from 'react-widgets/lib/DateTimePicker'

import { AutoComplete as MUIAutoComplete } from 'material-ui'
import { AutoComplete, } from 'redux-form-material-ui'


const renderField = ({
    input,
    type,
    placeholder,
    label,
    disabled,
    readOnly,
    meta: { touched, error, warning },
}) => (
        <Row>
            <Col md="12">
                <Label htmlFor="{input}" className="col-form-label">
                    {label}
                </Label>
            </Col>
            <Col md="12">
                <Input
                    {...input}
                    type={type}
                    placeholder={placeholder}
                    disabled={disabled}
                    readOnly={readOnly}
                ></Input>
                {touched &&
                    ((error && <p style={{ color: "red" }}>{error}</p>) ||
                        (warning && <p style={{ color: "brown" }}>{warning}</p>))}
            </Col>
        </Row>
    );

const validate = values => {
    const pattern = /[a-zA-Z0-9]+[\.]?([a-zA-Z0-9]+)?[\@][a-z]{3,9}[\.][a-z]{2,5}/g;

    const errors = {}

    //--------------------------------------------------------------------------------------------------------

    if (!values.nombre || values.nombre === "") {
        errors.nombre = "Debes ingresar el concepto del gasto";
    }

    if (!values.monto || values.monto === "") {
        errors.monto = "Debes ingresar el valor del gasto";
    }

    return errors
}

const renderFromHelper = ({ touched, error }) => {
    if (!(touched && error)) {
        return
    } else {
        return <FormHelperText>{touched && error}</FormHelperText>
    }
}



const mapStateToProps = (state) => {

    let nombre          = "";
    let monto           = "";
    let idusuarioalta   = sessionStorage.getItem('idusuario');
    let alias           = sessionStorage.getItem('alias');

    return {
        initialValues: {
            nombre,
            monto,
            idusuarioalta,
            alias
        }
    };

}; //END MAPSTATETOPROPS


class GCForm extends Component {

    

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>

                <FormGroup row>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="nombre"
                                component={renderField}
                                label="Concepto :"
                            />
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="number"
                                name="monto"
                                component={renderField}
                                label="Monto :"
                            />
                        </FormGroup>
                    </Col>

                    <Col md={3}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="idusuarioalta"
                                component={renderField}
                                label="ID SUARIO:" disabled
                            />
                        </FormGroup>
                    </Col>

                    <Col md={3}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="alias"
                                component={renderField}
                                label="ALIAS USUARIO:" disabled 
                            />
                        </FormGroup>
                    </Col>


                </FormGroup>

                <FormGroup row>
                    <Col md="12">
                        <FormGroup>
                            {
                                !this.props.submitSucceeded ? (
                                    <Button
                                        color="dark"
                                        type="submit"
                                        disabled={this.props.submitSucceeded}

                                    >
                                        Enviar
                                    </Button>
                                ) : (
                                        <Button variant="success" disabled>
                                            <Spinner
                                                as="span"
                                                animation="grow"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                variant="success"
                                                role="status"
                                            />
                                            Procesando solicitud...
                                        </Button>

                                    )

                            }

                        </FormGroup>
                    </Col>
                </FormGroup>

            </form>
        );
    }
}

GCForm = reduxForm({
    form: "formGCGC",
    validate,
    enableReinitialize: true,
})(GCForm);
export default connect(mapStateToProps, null)(GCForm);